import { combineReducers } from 'redux';
import users from './users';
import zerodha from './zerodha';

// ✅ Combine all your reducers here
const rootReducer = combineReducers({
  users,
  zerodha
});

export default rootReducer;